import { useState } from "react";
import Modal from "react-bootstrap/Modal";

export const SearchBusinessPartnersPublish = () => {
    const [show, setShow] = useState(true);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return <>
        <Modal
            className="my_modal"
            show={show}
            onHide={handleClose}
            centered
            size={"xl"}
        >
            <Modal.Header closeButton>
                <Modal.Title>거래처 검색​</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex mb-15px">
                    <select className="form-select w-120px">
                        <option>전체</option>
                    </select>
                    <input type="text" className="form-control w-250px ms-5px h-34px" />
                    <button
                        type="button"
                        className="btn btn-info btn_search w-80px ms-5px"
                    >
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                            alt=""
                        />
                        조회
                    </button>
                </div>
                <table className="table table-bordered my_table table_modal m-0">
                    <thead>
                        <tr>
                            <th style={{ width: "7.1%" }}></th>
                            <th>소속분류</th>
                            <th>산업구분​</th>
                            <th>회사명​</th>
                            <th>기본 연락처​</th>
                            <th>담당자​</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input className="form-check-input" type="radio" checked />
                                </div>
                            </td>
                            <td className="text-center">MS</td>
                            <td className="text-center">Compact</td>
                            <td className="text-center">S1-WIN…</td>
                            <td className="text-center">TNA-00022</td>
                            <td className="text-center">OS</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input className="form-check-input" type="radio" />
                                </div>
                            </td>
                            <td className="text-center">MS</td>
                            <td className="text-center">Compact</td>
                            <td className="text-center">S1-WIN…</td>
                            <td className="text-center">TNA-00022</td>
                            <td className="text-center">OS</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input className="form-check-input" type="radio" />
                                </div>
                            </td>
                            <td className="text-center">MS</td>
                            <td className="text-center">Compact</td>
                            <td className="text-center">S1-WIN…</td>
                            <td className="text-center">TNA-00022</td>
                            <td className="text-center">OS</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input className="form-check-input" type="radio" />
                                </div>
                            </td>
                            <td className="text-center">MS</td>
                            <td className="text-center">Compact</td>
                            <td className="text-center">S1-WIN…</td>
                            <td className="text-center">TNA-00022</td>
                            <td className="text-center">OS</td>
                        </tr>
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                >
                    <img
                        src={
                            process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"
                        }
                        alt=""
                    />
                    목록
                </button>
                <button type="button" className="btn btn-dark w-100px h-38px my-0">
                    목록
                </button>
            </Modal.Footer>
        </Modal>
    </>
}